import { ProductTypeEnum } from "@shared/enums";
import { CheckboxFilterElement } from "./checkboxFilter.element";

export class AbFilterProductTypeElement extends CheckboxFilterElement<ProductTypeEnum> {
  constructor() {
    super({ label: "Tipologia prodotto", eventName: "product-type-filter-change", optionLabel: (value) => value });
  }
}

export const defineAbFilterProductTypeElement = () => {
  if (!customElements.get("ab-filter-product-type")) customElements.define("ab-filter-product-type", AbFilterProductTypeElement);
};
